import React from "react";

/*
    Logout Icon
    props:
        - title: string, override the default title 'Logout'
        - color: string, override the default color '#00549A' (bell blue)
*/

const LogoutIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Logout"}</title>
        <path
            d="M10.5 3.75L3.80078 3.75V20.25H10.5M8.18741 11.8499L20.2497 11.8473M15.9023 7.5L20.2497 11.8473M20.2497 11.8473L15.9023 16.1947"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default LogoutIcon;
